import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
export default function NavBar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [impersonating, setImpersonating] = useState(null);
  const isPro = user?.subscription_tier !== 'free';

  useEffect(() => {
    const val = localStorage.getItem('impersonating_user');
    setImpersonating(val);
  }, []);

  const returnToAdmin = () => {
    const adminToken = localStorage.getItem('admin_return_token');
    if (adminToken) {
      localStorage.setItem('token', adminToken);
      localStorage.removeItem('admin_return_token');
      localStorage.removeItem('impersonating_user');
      window.location.href = '/admin';
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) { .nav-desktop-links { display: none !important; } .nav-hamburger { display: flex !important; } }
        @media (min-width: 769px) { .nav-hamburger { display: none !important; } }
      `}</style>
      {impersonating && (
        <div style={{background:'#ffc107', padding:'8px 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:'13px', fontWeight:'500', color:'#1a1a1a'}}>
          <span>👁 Admin view — viewing as <strong>{impersonating}</strong></span>
          <button onClick={returnToAdmin} style={{background:'#1a1a1a', color:'#fff', border:'none', borderRadius:'6px', padding:'5px 12px', fontSize:'12px', cursor:'pointer', fontWeight:'500'}}>Return to admin</button>
        </div>
      )}
      <nav style={s.nav}>
        <a href="/" style={s.logo}>CryptoFolio <span style={s.accent}>CFO</span></a>
        <div style={s.right}>
          <div className="nav-desktop-links" style={s.links}>
            <a href="/dashboard" style={s.link}>Dashboard</a>
            {isPro && <a href="/wealth" style={s.link}>Wealth Planner</a>}
            {isPro && <a href="/llc" style={s.link}>LLC/S-Corp</a>}
            <a href="/tax" style={s.link}>Tax Snapshot</a>
            {isPro && <a href="/chart-room" style={s.link}>Chart Room</a>}
            <a href="/settings" style={s.link}>Settings</a>
            <button onClick={logout} style={s.logout}>Sign out</button>
          </div>
          <div className="nav-hamburger" style={{display:'none', flexDirection:'column', gap:'5px', cursor:'pointer', padding:'6px'}} onClick={() => setOpen(!open)}>
            <div style={{width:'22px', height:'2px', background:'#6b6b6b'}}></div>
            <div style={{width:'22px', height:'2px', background:'#6b6b6b'}}></div>
            <div style={{width:'22px', height:'2px', background:'#6b6b6b'}}></div>
          </div>
        </div>
      </nav>
      {open && (
        <div style={s.mobileMenu}>
          <a href="/dashboard" style={s.mobileLink} onClick={() => setOpen(false)}>Dashboard</a>
          {isPro && <a href="/wealth" style={s.mobileLink} onClick={() => setOpen(false)}>Wealth planner</a>}
          {isPro && <a href="/llc" style={s.mobileLink} onClick={() => setOpen(false)}>LLC / S-Corp calculator</a>}
          <a href="/tax" style={s.mobileLink} onClick={() => setOpen(false)}>Tax snapshot</a>
          {isPro && <a href="/chart-room" style={s.mobileLink} onClick={() => setOpen(false)}>Chart Room</a>}
          <a href="/settings" style={s.mobileLink} onClick={() => setOpen(false)}>Settings</a>
          <button onClick={() => { logout(); setOpen(false); }} style={s.mobileLogout}>Sign out</button>
        </div>
      )}
    </>
  );
}
const s = {
  nav: { background:'#fff', borderBottom:'1px solid rgba(0,0,0,0.08)', padding:'0 1.5rem', height:'60px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'relative', zIndex:50 },
  logo: { fontFamily:'Georgia, serif', fontSize:'18px', color:'#1a1a1a', textDecoration:'none', whiteSpace:'nowrap' },
  accent: { color:'#1a6b4a' },
  right: { display:'flex', alignItems:'center' },
  links: { display:'flex', alignItems:'center', gap:'16px' },
  link: { fontSize:'13px', color:'#6b6b6b', textDecoration:'none', whiteSpace:'nowrap' },
  logout: { fontSize:'13px', color:'#6b6b6b', background:'transparent', border:'none', cursor:'pointer', whiteSpace:'nowrap' },
  mobileMenu: { background:'#fff', borderBottom:'1px solid rgba(0,0,0,0.08)', padding:'1rem 1.5rem', display:'flex', flexDirection:'column', gap:'16px', position:'absolute', top:'60px', left:0, right:0, zIndex:49, boxShadow:'0 4px 12px rgba(0,0,0,0.08)' },
  mobileLink: { fontSize:'15px', color:'#1a1a1a', textDecoration:'none', padding:'4px 0' },
  mobileLogout: { fontSize:'15px', color:'#dc2626', background:'transparent', border:'none', cursor:'pointer', textAlign:'left', padding:'4px 0' }
};
